import posthog from 'posthog-js';

let initialized = false;

export function initPostHog(apiKey: string, apiHost: string): void {
    if (initialized || typeof window === 'undefined') return;
    posthog.init(apiKey, {
        api_host: apiHost,
        loaded: (ph) => {
            if (import.meta.env.DEV) ph.debug();
        }
    });
    initialized = true;
}

export { posthog };
